<script>
  import Nav from "./Nav.svelte";

  let { children } = $props();
</script>

<div class="min-h-screen w-full bg-black text-zinc-100 flex flex-col">
  <!-- Background gradient layer -->
  <div class="pointer-events-none fixed inset-0 -z-10">
    <div class="absolute inset-0 bg-[radial-gradient(900px_520px_at_85%_10%,rgba(255,255,255,0.08),transparent_62%)]"></div>
    <div class="absolute inset-0 bg-gradient-to-b from-[#07070a] via-[#050508] to-black"></div>
  </div>

  <Nav />
  <main class="flex-1 w-full px-4 sm:px-6 py-6">
    {@render children()}
  </main>
</div>
